import React from 'react';

const MARK_SRC = '/brand/xceed-logo-mark.png';
export const LOGO_FULL_SRC = '/brand/xceed-logo-full.png';

export function LogoMark({ size = 40, className = '' }) {
  return (
    <img
      src={MARK_SRC}
      alt="XceedAgents logo"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
}

export function LogoMarkLight({ size = 40, className = '' }) {
  return <LogoMark size={size} className={className} />;
}

export default function Logo({ size = 40, className = '', isDark = true }) {
  return <LogoMark size={size} className={className} />;
}
